export const UPLOAD_MESSAGES = {
  FILE_SUCCESS: "File uploaded successfully!",
  FILE_REMOVED: "File removed successfully!",
  EVALUATE_SUCCESS: "Submitted successfully!",
  EVALUATE_ERROR: "Please upload a transcript file or paste the transcript before evaluating.",
};
